import { FC } from 'react';
import {Modal} from './Modal'

import {useIntl} from 'react-intl'
import PrivacyPolicyContent from './PrivacyPolicyContent';

interface Props {
  show: boolean
  handleClose: () => void
}

const PrivacyPolicyModal: FC<Props> = ({ show, handleClose }) => {
  
  const intl = useIntl()

  return <Modal 
          show={show} 
          handleClose={handleClose} 
          title={intl.formatMessage({id: 'general.privacy'})} 
          dialogClassName="modal-dialog modal-dialog-centered w-lg-500px"
          modalBodyClassName="overflow-y-auto mh-500px">
      <PrivacyPolicyContent/>
    </Modal>
  }
  
  export {PrivacyPolicyModal}